var site = site || {};
(function($) {
  Drupal.behaviors.meetTheArtistFormatterV1 = {
    attach: function(context) {
      var self = this;
      var $formatter = $('.js-meet-the-artist-formatter-v1', context);

      // Loop through and init the carousels.
      // Carousels might contain variations, so dynamically change the settings before constructing slick
      $formatter.each(function() {
        var $this = $(this);
        var $carousel = $this.find('.js-meet-the-artist-formatter__carousel');
        var useResponsive = false;
        var autoplay = $carousel.data('slides-autoplay');
        var fade = $carousel.data('fade');
        var slidesToShow = parseInt($carousel.data('slides-show'));
        var slidesToScroll = parseInt($carousel.data('slides-scroll'));
        var slidesToShowMobile = parseInt($carousel.data('slides-show-mobile'));
        var slidesToScrollmobile = parseInt($carousel.data('slides-scroll-mobile'));
        var slidesArrowLeft = $carousel.data('arrow-left');
        var slidesArrowRight = $carousel.data('arrow-right');
        var arrowTopPosition = $carousel.data('arrow-top-position');
        // Responsive dots / arrows
        var pcDotsArrowsArgs = self.dotsAndArrows($carousel.data('dots-arrows-pc'));
        var mobileDotsArrowsArgs = self.dotsAndArrows($carousel.data('dots-arrows-mobile'));
        var speed = parseInt($carousel.data('speed'));
        var peekingPC = false;
        var peekingMob = false;
        var centerPadding = '30px';
        var offset;
        var slickPrev = '.slick-prev';
        var slickNext = '.slick-next';
        var slickScrollRtl = false;
        var dirSwap = $('html[dir="rtl"]').length;
        var settingsResponsive;

        // fade settings
        if (typeof fade === 'undefined') {
          fade = false;
        } else {
          fade = true;
        }

        runChecks();
        reverseScroll();

        settingsResponsive = {
          infinite: true,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          autoplay: autoplay,
          fade: fade,
          dots: pcDotsArrowsArgs.dots,
          arrows: pcDotsArrowsArgs.arrows,
          rows: 1,
          speed: speed,
          centerMode: peekingPC,
          centerPadding: centerPadding,
          rtl: slickScrollRtl,
          draggable: true,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                infinite: true,
                centerMode: peekingMob,
                centerPadding: centerPadding,
                dots: mobileDotsArrowsArgs.dots,
                arrows: mobileDotsArrowsArgs.arrows,
                slidesToShow: slidesToShowMobile,
                slidesToScroll: slidesToScrollmobile,
                draggable: true
              }
            }
          ]
        };

        checkResponsive();
        customArrows();

        // Handle RTL values.
        function reverseScroll() {
          if (dirSwap) {
            slickScrollRtl = true;
            $carousel.attr('dir', 'rtl');
          }
        }

        function checkCenterPadding() {
          if ($this.data('peaking-center-padding')) {
            centerPadding = $this.data('peaking-center-padding') + 'px';
          }
          if ($this.data('peaking-center-padding-percent')) {
            centerPadding = $this.data('peaking-center-padding-percent') + '%';
          }
          if ($this.data('peeking_offset')) {
            offset = $this.data('peeking_offset') + 'px';
          }
        }

        function checkAutoPlay() {
          if (typeof autoplay === 'undefined') {
            autoplay = false;
          } else {
            autoplay = true;
          }
        }

        function runChecks() {
          // peeking settings
          if ($this.hasClass('js-meet-the-artist-formatter--pc_peeking')) {
            peekingPC = true;
          }
          if ($this.hasClass('js-meet-the-artist-formatter--mob-peeking')) {
            peekingMob = true;
          }
          checkCenterPadding();
          checkAutoPlay();
        }

        function checkResponsive() {
          // slide counts
          if (slidesToShowMobile > 2) {
            useResponsive = true;
          }
          $carousel.not('.slick-initialized').on('init', function() {
            if ($this.data('peaking-center-padding')) {
              if ($this.hasClass('js-mob-peeking-align-left')) {
                var leftOffset = offset ? offset : centerPadding;
                $this.find('.slick-list').css('left', '-' + leftOffset);
              }
            }
          });
          $carousel.on('afterChange', function() {
            var dataId = $carousel.find('.slick-current').attr('data-slick-index');
            $.event.trigger({
              type: 'basic_carousel_formatter:current_slide',
              payload: dataId
            });
          });

          $carousel.on('beforeChange', function(event, slick, currentSlide) {
            if (slick['$nextArrow']) {
              currentSlide === slick.slideCount - 2 ? slick['$nextArrow'].addClass('hide') : slick['$nextArrow'].removeClass('hide');
            }
            if (slick['$prevArrow']) {
              currentSlide === 1 ? slick['$prevArrow'].addClass('hide') : slick['$prevArrow'].removeClass('hide');
            }
          });

          $carousel.not('.slick-initialized').slick(settingsResponsive);
        }

        // Set the custom image sources.
        function customArrows() {
          checkCustomArrows(slickPrev, slidesArrowLeft);
          checkCustomArrows(slickNext, slidesArrowRight);
        }
        // Check the custom arrows.
        function checkCustomArrows(dir, dataAttr) {
          if (!($this.find(dir).css('background-image') === 'url(' + dataAttr + ')')) {
            $this.find(dir).css('background-image', 'url(' + dataAttr + ')');
            if (dataAttr) {
              $this.find(dir).addClass('no-before');
            }
            if (arrowTopPosition) {
              $this.find(dir).css('top', arrowTopPosition);
            }
          }
        }
        // Handle custom image source when the window is resized,
        // as slick re-initialises for its responsive settings.
        $(window).on('resize', _.debounce(customArrows, 100));
      });
    },
    dotsAndArrows: function(dotsAndArrows) {
      var dotsArrowsArgs = {};
      switch (dotsAndArrows) {
        case 'arrows':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = true;
          break;
        case 'both':
          dotsArrowsArgs.dots = true;
          dotsArrowsArgs.arrows = true;
          break;
        case 'none':
          dotsArrowsArgs.dots = false;
          dotsArrowsArgs.arrows = false;
          break;
      }
      return dotsArrowsArgs;
    },
  };
})(jQuery);
